// import React from "react";
// import { Navigate, Outlet, useLocation } from "react-router-dom";
// import Admlayout from "../components/admlayout";

// const AdminPrivateRoute = () => {
//     const auth = JSON.parse(localStorage.getItem("authAdm"));
//     const location = useLocation();

//     const isAuthorized = auth && auth.authorized && (auth.type === "admin" || auth.type === "teacher");

//     if (!isAuthorized) {
//         return (
//             <Admlayout>
//                 <Navigate to={`/adm/admlogin?redirect=${encodeURIComponent(location.pathname)}`} replace />
//             </Admlayout>
//         );
//     }

//     return (
//         <Admlayout>
//             <Outlet />
//         </Admlayout>
//     );
// };

// export default AdminPrivateRoute;
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Admlayout from "../components/admlayout";
import axios from "axios";
import { backend } from './apipath';


const AdminPrivateRoute = () => {
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        axios.get(`${backend}login/checkAuth`, { withCredentials: true })
            .then(res => {
                if (res.data?.authorized && (res.data.type === 'admin' || res.data.type === 'teacher')) {
                    setIsAuthorized(true);
                }
                setIsLoading(false);
            })
            .catch(() => setIsLoading(false));
    }, []);

    if (isLoading) return <div>Loading...</div>;

    if (!isAuthorized) {
        return (
            <Admlayout>
                <Navigate to={`/adm/admlogin?redirect=${encodeURIComponent(location.pathname)}`} replace />
            </Admlayout>
        );
    }

    return (
        <Admlayout>
            <Outlet />
        </Admlayout>
    );
};

export default AdminPrivateRoute;
